// extracted by mini-css-extract-plugin
module.exports = {"power-preparedness-D":"D_power-preparedness-D__20Oc1"};